module.exports = __webpack_public_path__ + "img/20210211_095009.ccecb716.jpg";